export default __webpack_public_path__ + "static/media/403_error.df873bd4.png";